/* eslint-disable @angular-eslint/no-inputs-metadata-property */
/* eslint-disable @typescript-eslint/no-empty-interface */
import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Divider, DividerModule } from "primeng/divider";
import { WrapperBase } from "../base";
import { Wrapper } from "../decorators";
import { CommonModule } from "@angular/common";

@Component({
    selector:      'v-divider',
    encapsulation: ViewEncapsulation.None,
    template:      '<p-divider #component><ng-content></ng-content></p-divider>',
    providers:     [{ provide: Divider, useExisting: VDividerComponent }],
    inputs:        ["align", "layout", "type", "style", "styleClass"],
    standalone:    true,
    imports:       [DividerModule, CommonModule]
})
@Wrapper(Divider)
export class VDividerComponent extends WrapperBase implements OnInit {
}
export interface VDividerComponent extends Divider {}
